/** Disclaimer type keys — matches Data.Core.DisclaimerTypes */
export const DISCLAIMER_TYPES = ['terms', 'privacy', 'cookie', 'warning'] as const;

export type DisclaimerTypeKey = (typeof DISCLAIMER_TYPES)[number];

export const DISCLAIMER_TYPE_LABELS: Record<DisclaimerTypeKey, string> = {
  terms: 'Terms of Service',
  privacy: 'Privacy Policy',
  cookie: 'Cookie Policy',
  warning: 'Warning',
};

export const DISCLAIMER_LANGUAGES = [
  { value: 'en', label: 'English' },
  { value: 'tr', label: 'Türkçe' },
  { value: 'es', label: 'Español' },
  { value: 'fr', label: 'Français' },
  { value: 'de', label: 'Deutsch' },
  { value: 'ja', label: '日本語' },
] as const;

export type DisclaimerLanguage = (typeof DISCLAIMER_LANGUAGES)[number]['value'];

export interface Disclaimer {
  id: number;
  typeKey: DisclaimerTypeKey | string;
  language: string;
  title: string;
  content: string;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface DisclaimerTypeOption {
  key: DisclaimerTypeKey | string;
  label: string;
}

export interface CreateDisclaimerRequest {
  typeKey: string;
  language: string;
  title: string;
  content: string;
  isActive: boolean;
}

export type UpdateDisclaimerRequest = CreateDisclaimerRequest;
